<template>
    <div
        class="z-table z-table--scrollable"
        :class="{
            [`z-table--centered`]: contentCentered,
            [`z-table--with-merged-rows`]: rowsMerged
        }"
    >
        <div class="z-table__container">
            <table>
                <colgroup v-if="colgroup && colgroup.length && isNotMobile">
                    <col
                        v-for="(item, index) in colgroup"
                        :key="index"
                        span="1"
                        :style="`width: ${item};`"
                    >
                </colgroup>
                <thead>
                    <slot name="head"/>
                </thead>
                <tbody>
                    <slot />
                </tbody>
            </table>
        </div>
        <div class="z-table__footer" v-if="hasAddSlotData">
            <slot name="add" />
        </div>
    </div>
</template>

<script setup>
import {computed, useSlots} from 'vue'
import {useGetter} from '@/composable/useGetter'

const props = defineProps({
    responsive: {
        type: Boolean
    },
    scrollable: {
        type: Boolean
    },
    native: {
        type: Boolean
    }, // for default auto width column
    contentCentered: {
        type: Boolean
    },
    rowsMerged: {
        type: Boolean
    },
    colgroup: {
        type: Array,
        default: () => []
    }
})

const slots = useSlots()
const { device } = useGetter(['device'])

const isNotMobile = computed(() => device.value !== 'mobile')

const hasAddSlotData = computed(() => {
    return slots.add
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
